import { ObjectValues } from "@/src/shared/types/objectValues";
import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import type { DSColorPalette } from "@/src/design_system/shared/types/colorPalette.generated";
import { DS_ALIGN } from "@/src/design_system/shared/types/align";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type {
  DSAppearanceProps,
  DSAriaLabelProps,
  DSSizingProps,
  DSStatefulProps,
} from "@/src/design_system/shared/types/props";

export const DS_BUTTON_VARIANT = {
  Primary: "primary",
  Secondary: "secondary",
  Tertiary: "tertiary",
  Ghost: "ghost",
} as const;

export const DS_BUTTON_TYPE = {
  Button: "button",
  Submit: "submit",
  Reset: "reset",
} as const;

export const DS_BUTTON_SIZE = {
  ExtraSmall: DS_SIZE.ExtraSmall,
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
} as const;

export type DSButtonVariant = ObjectValues<typeof DS_BUTTON_VARIANT>;
export type DSButtonType = ObjectValues<typeof DS_BUTTON_TYPE>;
export type DSButtonSize = ObjectValues<typeof DS_BUTTON_SIZE>;

export interface DSButtonTurboProps {
  turbo?: boolean;
  turboFrame?: string;
  turboMethod?: string;
  turboConfirm?: string;
  action?: string;
  turboSubmitsWith?: string;
}

export type DSButtonProps = DSButtonTurboProps &
  DSAriaLabelProps &
  Pick<DSStatefulProps, "disabled"> &
  DSSizingProps<DSButtonSize> &
  DSAppearanceProps<(typeof DS_ALIGN)["Left"], DSColorPalette | null> & {
    variant?: DSButtonVariant;
    tabindex?: number;
    prefixIcon?: DSIconName;
    suffixIcon?: DSIconName;
    type?: DSButtonType;
    fullWidth?: boolean;
    name?: string;
    value?: string;
    form?: string;
    formAction?: string;
    formMethod?: string;
    href?: string;
    target?: string;
    onclick?: string;
  };
